import { Box, Stack, styled, Typography } from '@mui/material';
import { colorPaletteLight } from '@sb/cc-design-system';

export const RootContainer = styled(Box)`
  width: 100%;
  height: calc(100vh - 104px);
`;

export const SearchToolbarStack = styled(Stack)`
  align-items: center;
  gap: 8px;
  min-width: 0;
  width: 100%;
`;

export const SearchToolbarActions = styled(Stack)`
  align-items: center;
  flex-shrink: 0;
`;

export const FilterHeaderStack = styled(Stack)`
  flex-direction: row;
  justify-content: flex-end;
  padding-bottom: 10px;
  width: 100%;
`;

export const FilterBadge = styled(Typography)`
  background-color: ${colorPaletteLight.primary.blue.main};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
`;
